import { getFilterSectionFields } from '../../config/filterFields';
import { getStateByCode } from 'helperFunctions';
import { getShouldCalculateAgeRange, pushRangeOfNumbers } from '../../helperFunctions';

export const defaultFilterState = () => ({
  Age: [],
  Gender: [],
  Homeownership: [],
  Ethnicity: [],
  Origin: [],
  Income: [],
  State: [],
  Location: [],
  PersonalIdeology_1: [],
  Education: [],
  Marital_status: [],
});

export const defaultSelectValues = () => ({ State: 0 });

export const hasActiveFilters = filters => {
  if (!filters) return false;
  return Object.values(filters).some(value => Array.isArray(value) && value.length);
};

export const mapIncomeGroupToBracket = incomeGroupArr => {
  let bracketValues = [];

  incomeGroupArr.forEach(incomeGroupItem => {
    const parsedItem = JSON.parse(incomeGroupItem);

    for (let i = parsedItem[0]; i <= parsedItem[1]; i++) {
      bracketValues.push(i);
    }
  });

  bracketValues.sort((a, b) => a - b);

  return bracketValues;
};

export const buildFiltersFromFormData = (formData, rangeWasTouched = false) => {
  const shouldCalculateAgeRange = getShouldCalculateAgeRange();
  const preparedFilterData = defaultFilterState();
  const filterToSend = defaultFilterState();

  formData.forEach((value, name) => {
    switch (name) {
      case 'Age':
        if (value[0] !== '[') {
          if (rangeWasTouched && shouldCalculateAgeRange) {
            let parsedValue = value.split(',');
            parsedValue = parsedValue.map(element => Number(element));
            preparedFilterData.Age.push(parsedValue);
            filterToSend.Age.push(parsedValue);
          }
        } else {
          preparedFilterData.Age.push(JSON.parse(value));
          filterToSend.Age.push(JSON.parse(value));
        }
        break;
      case 'Gender':
        if (Number(value) === 3) {
          preparedFilterData.Gender.push(Number(value));
          filterToSend.Gender = pushRangeOfNumbers(filterToSend.Gender, 3, 6);
        } else {
          preparedFilterData.Gender.push(Number(value));
          filterToSend.Gender.push(Number(value));
        }
        break;
      case 'Income':
        if (value[0] === '[') {
          preparedFilterData.Income.push(value);
        } else {
          preparedFilterData.Income.push(Number(value));
        }
        if (isNaN(Number(value))) {
          let parsedValue = JSON.parse(value);
          filterToSend.Income = pushRangeOfNumbers(filterToSend.Income, parsedValue[0], parsedValue[1]);
        } else {
          filterToSend.Income.push(Number(value));
        }
        break;
      case 'State':
        if (Number(value) !== 0) {
          preparedFilterData.State.push(Number(value));
          filterToSend.State.push(Number(value));
        }
        break;
      default:
        if (name === 'Region') break;

        preparedFilterData[name].push(Number(value));
        filterToSend[name].push(Number(value));
        break;
    }
  });

  return { preparedFilterData, filterToSend };
};

export const formatLabelValue = key => {
  if (key === 'PersonalIdeology_1') {
    return 'Ideology';
  }

  return key;
};

export const formatFilterValue = (key, valueToMap, pickedBatchCountry) => {
  switch (key) {
    case 'Age':
      return mapAgeFilterValue(key, valueToMap);
    case 'State':
      return getStateByCode(valueToMap);
    case 'Ethnicity':
      return mapEthnicityFilterValue(valueToMap);
    case 'Origin':
      return mapOriginFilterValue(valueToMap, pickedBatchCountry);
    case 'Education':
      return mapEducationFilterValue(valueToMap);
    case 'Gender':
      return mapGenderFilterValue(valueToMap);
    case 'Homeownership':
      return mapHomeownershipFilterValue(valueToMap);
    case 'Income':
      return mapIncomeFilterValue(valueToMap, pickedBatchCountry);
    case 'Location':
      return mapLocationFilterValue(valueToMap, pickedBatchCountry);
    case 'PersonalIdeology_1':
      return mapPersonalIdeologyFilterValue(valueToMap);
    case 'Marital_status':
      return mapMaritalStatusFilterValue(valueToMap);
    default:
      break;
  }
};

const mapAgeFilterValue = (key, valueToMap) => {
  let value = '';
  const valueToMapFormated = `[${valueToMap.toString()}]`;

  getFilterSectionFields().forEach(section => {
    if (section.id == key) {
      section.sections[0].fields.forEach(field => {
        if (field.value == valueToMapFormated) {
          value = field.value;
        }
      });
    }
  });

  if (value) {
    return value;
  } else {
    getFilterSectionFields().forEach(section => {
      if (section.id == key) {
        section.sections[2].fields.forEach(field => {
          if (field.value == valueToMapFormated) {
            value = field.value;
          }
        });
      }
    });

    return value ? value : valueToMapFormated;
  }
};

const mapEthnicityFilterValue = valueToMap => {
  let value = '';

  getFilterSectionFields().forEach(section => {
    if (section.id == 'Ethnicity') {
      section.fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};

const mapOriginFilterValue = (valueToMap, pickedBatchCountry) => {
  let value = '';
  getFilterSectionFields(pickedBatchCountry).forEach(section => {
    if (section.id == 'Origin') {
      section.fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};

const mapEducationFilterValue = valueToMap => {
  let value = '';

  getFilterSectionFields().forEach(section => {
    if (section.id == 'Education') {
      section.fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};

const mapGenderFilterValue = valueToMap => {
  let value = '';

  getFilterSectionFields().forEach(section => {
    if (section.id == 'Gender') {
      section.fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};

const mapHomeownershipFilterValue = valueToMap => {
  let value = '';

  getFilterSectionFields().forEach(section => {
    if (section.id == 'Homeownership') {
      section.fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};

const mapIncomeFilterValue = (valueToMap, pickedBatchCountry) => {
  let value = '';

  if (valueToMap[0] === '[') {
    getFilterSectionFields(pickedBatchCountry).forEach(section => {
      if (section.id == 'Income') {
        section.sections[0].fields.forEach(field => {
          if (field.value == valueToMap) {
            value = field.label;
          }
        });
      }
    });
  } else {
    getFilterSectionFields(pickedBatchCountry).forEach(section => {
      if (section.id == 'Income') {
        section.sections[1].fields.forEach(field => {
          if (field.value == valueToMap) {
            value = field.label;
          }
        });
      }
    });
  }

  return value;
};

const mapLocationFilterValue = (valueToMap, pickedBatchCountry) => {
  let value = '';

  getFilterSectionFields(pickedBatchCountry).forEach(section => {
    if (section.id == 'Location') {
      section.sections[0].fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};

const mapMaritalStatusFilterValue = valueToMap => {
  let value = '';

  getFilterSectionFields().forEach(section => {
    if (section.id == 'Marital_status') {
      section.fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};

const mapPersonalIdeologyFilterValue = valueToMap => {
  let value = '';

  getFilterSectionFields().forEach(section => {
    if (section.id == 'PersonalIdeology_1') {
      section.fields.forEach(field => {
        if (field.value == valueToMap) {
          value = field.label;
        }
      });
    }
  });

  return value;
};
